import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { TRIGGER_BASE_PATH } from '../../../../../../../../features/meta/trigger/trigger-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/trigger/_trigger')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'cc-trigger-list',
        label: 'Triggers',
        to: TRIGGER_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
